import { render } from "./FtdChart.vue?vue&type=template&id=8925a61a&scoped=true"
import script from "./FtdChart.vue?vue&type=script&lang=js"
export * from "./FtdChart.vue?vue&type=script&lang=js"

import "./FtdChart.vue?vue&type=style&index=0&id=8925a61a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8925a61a"]])

export default __exports__